import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { styled } from '@mui/material/styles';

import TabContainer from '../../containers/TabContainer/TabContainer';
import ContextStore from '../../modules/context';
import RequisitionTab from './RequisitionTab';
import FabAdd from '../../components/FabAdd';

const Root = styled('div')(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
}));

function Requisition() {
  const { formatMessage } = useIntl()
  const { setBreadcrumbs, currentUser } = useContext(ContextStore)
  const navigate = useNavigate()
  const location = useLocation()
  const [activeTabIndex, setActiveTabIndex] = useState(undefined);
  const { tabName } = useParams()

  useEffect(() => {
    setBreadcrumbs([{
      text: formatMessage({ id: 'sideMenu.purchase.requisition' })
    }])
    const pathname = location.pathname
    if (pathname === '/purchase/requisition/pending' && activeTabIndex !== 0) {
      setActiveTabIndex(0)
    } else if (pathname === '/purchase/requisition/done' && activeTabIndex !== 1) {
      setActiveTabIndex(1)
    } else if (pathname === '/purchase/requisition/void' && activeTabIndex !== 2) {
      setActiveTabIndex(2)
    }
    return () => {
    };
  }, [location.pathname]);

  const onTabSelected = (tabIndex) => {
    if (tabIndex === 0) {
      navigate('/purchase/requisition/pending');
    } else if (tabIndex === 1) {
      navigate('/purchase/requisition/done');
    } else {
      navigate('/purchase/requisition/void');
    }
  };

  const tabs = [
    { label: formatMessage({ id: 'requisition.tab.pending' }), component: <RequisitionTab /> },
    { label: formatMessage({ id: 'requisition.tab.done' }), component: <RequisitionTab /> },
    { label: formatMessage({ id: 'requisition.tab.void' }), component: <RequisitionTab /> },
  ]
  const defaultSelect = tabName === 'void' ? 2 : (tabName === 'done' ? 1 : 0)

  return (
    <Root>
      {currentUser.userRights['requisition-create'] === true && <FabAdd to="/purchase/requisition/edit/new" />}
      <TabContainer activeTabIndex={activeTabIndex} defaultSelect={defaultSelect} tabs={tabs} onTabSelected={onTabSelected} />
    </Root>
  );
}

export default Requisition;
